import type { ReactNode } from 'react';
import React from 'react';

function Content({ children }: { children: ReactNode }) {
  return (
    <>
      <div id="content" data-testid="content" />
      {children}
    </>
  );
}

Content.displayName = 'Content';

export { Content };
